















import AppForm from "../atoms/AppForm.vue";
import Vue from "vue";
type Data = {
  servingForItem: string;
};

export default Vue.extend({
  components: {
    AppForm
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    servingFor: {
      type: String,
      default: ""
    }
  },
  data(): Data {
    return {
      servingForItem: this.servingFor
    };
  },
  methods: {
    onChangeServingFor(servingForItem: string): void {
      this.$emit("on-change-serving-for", servingForItem);
    }
  }
});
